/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Account_PersonalInputs */

const cs_social_export_account_personal = /** @type {(inputs: Social_Export_Account_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osobní účet`)
};

const en_social_export_account_personal = /** @type {(inputs: Social_Export_Account_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal account`)
};

/**
* | output |
* | --- |
* | "Personal account" |
*
* @param {Social_Export_Account_PersonalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_account_personal = /** @type {((inputs?: Social_Export_Account_PersonalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Account_PersonalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_account_personal(inputs)
	return cs_social_export_account_personal(inputs)
});